exports = module.exports = require("../../../../../../../shared/frontend/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.partnership-block[data-v-1a0204f6] {\n  background: rgb(249, 249, 249);\n  border-radius: 5px;\n}\n.form-group[data-v-1a0204f6] {\n  margin-bottom: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/css-loader?{"minimize":false,"sourceMap":false}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/style-compiler?{"id":"data-v-1a0204f6","scoped":true,"hasInlineConfig":true}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Techcenter/components/TcPartnership.vue
// module id = 778
// module chunks = 1